import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {API_ROOT} from '../../../../baseUrls';
import Loader from '../../../organisms/loader/Loader';
import ItemViewDialog from "../../explore/items/item-viewer/ItemViewDialog";
import {getMindfileItemAdmin as getMindfileItem, setViewItem} from "../../../../state/actions/getDataActions";

function Files(props) {
  const { user, viewItem, setViewItem, getMindfileItem } = props;
  const [fileData, setFileData] = useState({});
  const [loading, setLoading] = useState(true);
  const [viewOpen, setViewOpen] = useState(false);

  useEffect(() => {
    startFileLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startFileLoad = () => {
    setLoading(true);
    fetch(`${API_ROOT}/mindfiles/${user.mid}/admin/files`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(data => {
      setFileData(data);
      setLoading(false);
    })
    .catch(error => console.error(error));
  }

  const onClickRow = (row, e) => {
    openItemViewDialog(row.mindfile_id, row.id, e);
  }

  const openItemViewDialog = (mindfileId, viewItemId, e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    Promise.allSettled([
      getMindfileItem(mindfileId, viewItemId, false, (item) => {
        if(!item){
          return;
        }
        setViewItem(item);
        setViewOpen(true);
      }, false)
    ]).catch(err => console.error(err));
  };

  const closeItemViewDialog = (e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setViewOpen(false);
    setViewItem(null);
  };

  // if (this.state.loading || this.props.uploadsStatus !== 'done') {
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <h2>Total Downloads</h2>
      <FileTable files={fileData.downloads} onClickRow={onClickRow} />
      <h2>Total Views</h2>
      <FileTable files={fileData.views} onClickRow={onClickRow} />

      {/*<FileDialog*/}
      {/*  isOpen={this.state.fileDialogIsOpen}*/}
      {/*  closeDialog={() => this.setState({ fileDialogIsOpen: false })}*/}
      {/*  updateMindfileUploads={this.startFileLoad.bind(this)}*/}
      {/*/>*/}
      {viewOpen && viewItem ?
        <ItemViewDialog
          id="itemViewDialog"
          item={viewItem}
          setItem={setViewItem}
          mindfileUserLevel={0}
          canSelect={false}
          showToolbar={false}
          showStatusIcon={true}
          isOpen={viewOpen}
          openDataView={null}
          closeDialog={closeItemViewDialog}
          handleCancel={closeItemViewDialog}
          title={`View ${viewItem.name}`}
          getMindfileItem={getMindfileItem}
          mindfileDisplay={null}
        /> : null }
    </div>
  );
}

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    viewItem: state.viewItem,
    user: state.auth,
  };
}

const mapDispatchToProps = {
  setViewItem,
  getMindfileItem
};

// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Files));

export default connect(mapStateToProps, mapDispatchToProps)(Files);

function FileTable(props) {
  return (
    <TableContainer style={{ maxHeight: '15em' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell key='name'>File</TableCell>
            <TableCell key='mindfile_name'>Mindfile</TableCell>
            <TableCell key='count'>#</TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: "#fff"}}>
          {props.files.map(row => (
            <TableRow key={row.id} hover role="checkbox" tabIndex={-1} style={{ cursor: 'pointer' }} onClick={(e) => props.onClickRow(row, e)}>
              <TableCell key='name'>{row.name}</TableCell>
              <TableCell key='mindfile_name'>{row.mindfile_name}</TableCell>
              <TableCell key='count'>{row.count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}